import { render, staticRenderFns } from "./VariableChip.vue?vue&type=template&id=5ecec2d3&"
import script from "./VariableChip.vue?vue&type=script&lang=ts&"
export * from "./VariableChip.vue?vue&type=script&lang=ts&"
import style0 from "./VariableChip.vue?vue&type=style&index=0&id=5ecec2d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports